import { inject } from '@angular/core'
import { HttpInterceptorFn } from '@angular/common/http'
import { TranslateService } from '../core/services/translate.service'

const LANG_TO_ACCEPT_LANGUAGE: Record<string, string> = {
  es: 'es-ES',
  en: 'en',
  fr: 'fr-FR',
  pt: 'pt',
  it: 'it-IT',
  de: 'de-DE',
  mx: 'es-MX',
  gt: 'es-GT',
}

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const translateService = inject(TranslateService)

  const lang = translateService.lang()
  const acceptLanguage = LANG_TO_ACCEPT_LANGUAGE[lang] ?? 'es-ES'

  const localizedReq = req.clone({
    setHeaders: { 'Accept-Language': acceptLanguage },
  })

  return next(localizedReq)
}
